<template>
  <component
    :is="tag"
    :to="to"
    :type="to ? null : type"
    class="ui-btn"
    :class="classes"
    v-on="listeners"
  >
    <v-icon v-if="icon" :size="size === 'sm' ? 14 : 16" color="currentColor">{{
      icon
    }}</v-icon>
    <slot></slot>
  </component>
</template>

<script>
/**
 * Dugme. variant: default | primary | accent | dark | ok | danger | ghost; size: md (40 px) | sm (34 px); block rasteže na cijelu širinu;
 * icon: mdi-ime ispred teksta. Sa `to` postaje veza (router-link) istog izgleda. Ostali atributi (disabled, title, aria-*) idu na sam element.
 */
export default {
  name: "UiButton",
  props: {
    variant: { type: String, default: "default" },
    size: { type: String, default: "md" },
    block: { type: Boolean, default: false },
    icon: { type: String, default: "" },
    to: { type: [String, Object], default: null },
    type: { type: String, default: "button" },
  },
  computed: {
    tag() {
      return this.to ? "router-link" : "button";
    },
    classes() {
      return [
        this.variant !== "default" && `ui-btn--${this.variant}`,
        this.size === "sm" && "ui-btn--sm",
        this.block && "ui-btn--block",
      ];
    },
    // router-link ne prosljeđuje događaje na element; za vezu klik rješava navigacija
    listeners() {
      return this.to ? {} : this.$listeners;
    },
  },
};
</script>
